import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClassesReportModel, ClassReportModel } from '@bayclubs/group-classes-employee-api';
import { TranslateService } from '@ngx-translate/core';
import { InstructorCentricClassItem, InstructorCentricSummary } from '../../models/instructor-centric-report-model';
import { ReportFilter, ReportType } from '../../models/reports-model';
import { ReportSelectService } from '../../services/report-select.service';
import { ReportsService } from '../../services/reports.service';
import { BaseReportComponent } from '../base/base-report.component';

@Component({
    selector: 'app-instructor-centric-report',
    templateUrl: './instructor-centric-report.component.html',
    styleUrls: ['./instructor-centric-report.component.scss'],
    standalone: false
})
export class InstructorCentricReportComponent extends BaseReportComponent implements OnInit, OnDestroy {
    reportData: InstructorCentricSummary[];

    constructor(
        activatedRoute: ActivatedRoute,
        reportSelectService: ReportSelectService,
        reportsService: ReportsService,
        translateService: TranslateService
    ) {
        super(activatedRoute, reportSelectService, reportsService, translateService);
    }

    ngOnInit() {
        this.reportType = ReportType.InstructorCentricReport;
        super.ngOnInit();
        this.reportData = [];
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }

    showReport(filter: ReportFilter) {
        if (filter === null) {
            this.generateDisabled = true;
            this.reportData = [];
        } else {
            this.subscriptions.add(
                this.reportsService.getInstructorCentricReportData(filter).subscribe((value: ClassesReportModel) => {
                    if (value.groupClasses !== null) {
                        this.generateReportData(value.groupClasses);
                        if (this.reportData.length > 0) {
                            this.generateDisabled = false;
                        }
                    }
                })
            );
        }
    }

    generateReportFile(filter: ReportFilter) {
        this.subscriptions.add(
            this.reportsService.generateInstructorCentricReportFile(filter).subscribe(value => {
                this.downloadReportFile(value, 'instructor-centric_');
            })
        );
    }

    private generateReportData(groupClasses: ClassReportModel[]) {
        let data: InstructorCentricSummary[] = [];
        groupClasses.forEach((groupClass: ClassReportModel) => {
            let summaryItem = data.find(p => p.instructorName === groupClass.instructorName);
            if (summaryItem === undefined) {
                summaryItem = new InstructorCentricSummary(groupClass.instructorName);
                data.push(summaryItem);
            }
            const instructorCentricItem = new InstructorCentricClassItem();
            this.fillClassItem(groupClass, instructorCentricItem);
            instructorCentricItem.clubName = groupClass.clubName;
            instructorCentricItem.clubShortName = groupClass.clubShortName;
            summaryItem.classes.push(instructorCentricItem);
        });
        data = this.calculateAndSortData(data);
        this.reportData = data;
    }
    private calculateAndSortData(data: InstructorCentricSummary[]): InstructorCentricSummary[] {
        return data.map(item => {
            item.totalHours = this.calculateSummaryRowTotalHours(item.classes);
            item.totalCost = this.calculateSummaryRowTotalCost(item.classes);
            item.classes = this.sort(item.classes, [{ date: 'asc', startTime: 'asc' }]);
            return item;
        });
    }
}
